// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".collection-body[data-v-2fda8632]{max-width:1024px}.marketing-content[data-v-2fda8632]{background-color:#f6f6f6;max-width:1024px}.marketing-content .marketing-content-img[data-v-2fda8632]{border-radius:12.5px}", ""]);
// Exports
module.exports = exports;
